// get list of payment method types and possible details

import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from '../constants';
import { PayInMethodType, PaymentMethodDetail } from './types';

type Response = {
  methodTypes: Array<{
    type: PayInMethodType;
    detail: PaymentMethodDetail;
  }>;
};

export default (makeCall: MakeCall) => () =>
  makeCall<Response>('GET', `${APIV2_URL}/payment/method-types`);
